import { render } from "./ResetPasswordIndex.vue?vue&type=template&id=367c6d9d"
import script from "./ResetPasswordIndex.vue?vue&type=script&lang=js"
export * from "./ResetPasswordIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__